<div class="d-flex flex-column gap-3">
  <ikp-vertragspartner-type-selection />
  <hr />
  @if (isDataReady()) {
    @if (vertriebsPartnerSelection() === VertragspartnerSelectionType.EIGENES_UNTERNEHMEN) {
      <ikp-own-company-information />
      <hr />
      <ikp-alternative-invoicing />
    } @else if (vertriebsPartnerSelection() === VertragspartnerSelectionType.ALTERNATIVE_PARTNER) {
      <ikp-vertragspartner-form />
      <hr />
      <h6>{{ 'meterPoint.meterPointChangeRequest.summary.newPartner.addressOfAbweichenderRechnungsempfaenger' | translate }}</h6>
      <ikp-own-company-information />
    }
  }
</div>
